import { render, staticRenderFns } from "./PageTutorial.vue?vue&type=template&id=068056b4&"
import script from "./PageTutorial.vue?vue&type=script&lang=js&"
export * from "./PageTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports